import * as Validators from "@/utils/validators";
export const title = {
    required: true
};

export const firstname = {
    required: true,
    validator: val => Validators.lengthBetween(2, 30, val),
    error: Validators.errorMessages.lengthBetween.supplant({ 0: 2, 1:30 })
};
export const lastname = {
    required: true,
    validator: val => Validators.lengthBetween(2, 30, val),
    error: Validators.errorMessages.lengthBetween.supplant({ 0: 2, 1:30 })
};
export const emailAddress = {
    required: true,
    validator: val => Validators.isValidEmail(val),
    error: Validators.errorMessages.email
};
export const postCode = {
    required: true,
    validator: val => Validators.isValidPostcode(val),
    error: Validators.errorMessages.postCode
};
export const qty = {
    required: true,
    validator: val => Validators.minValue(1, val),
};
export const number = {
    required: true,
    validator: val => Validators.isValidNumber(val)
};
export const address1 = {
    required: true,
    validator: val => Validators.lengthBetween(4, 30, val),
    error: Validators.errorMessages.lengthBetween.supplant({ 0: 4, 1:30 })
};
export const city = {
    required: true,
    validator: val => Validators.lengthBetween(4, 30, val),
    error: Validators.errorMessages.lengthBetween.supplant({ 0: 4, 1:30 })
};
export const county = {
    required: true,
    validator: val => Validators.lengthBetween(4, 30, val),
    error: Validators.errorMessages.lengthBetween.supplant({ 0: 4, 1:30 })
};
export const price = {
    required: true,
    validator: val => Validators.isValidAmount(20, val),
    error: Validators.errorMessages.decimalwithGreaterThan.supplant({ 0: 20 })
};
export const code = {
    required: true,
    validator: val => Validators.lengthBetween(4, 30, val),
    error: Validators.errorMessages.lengthBetween.supplant({ 0: 4, 1:30 })
};
export const name = {
    required: true,
    validator: val => Validators.lengthBetween(4, 30, val),
    error: Validators.errorMessages.lengthBetween.supplant({ 0: 4, 1:30 })
};
export const description = {
    required: true,
    validator: val => Validators.lengthBetween(4, 300, val),
    error: Validators.errorMessages.lengthBetween.supplant({ 0: 4, 1:300 })
};
export const dateOfBirth = {
    required: true
};
export const date = {
    required: true
};
export const occupation = {
    required: true
};

export const username = {
    required: true
};
export const password = {
    required: true,
    validator: val => Validators.isValidPassword(val),
    error: "Invalid password format"  
};
export const passwordRegistration = {
    required: true,
    validator: val => Validators.isValidPassword(val),
    error: Validators.errorMessages.passwordFormat  
};
export const confirmPassword = {
    required: true,
    validator: (val, oldVal) => Validators.passwordMatch(val, oldVal),
    error: "Passwords don't match",
    additionalParam: "item.password"  
};
export const phone = {
    required: true,
    validator: val => Validators.isValidTelephoneNumber(val),
    error: Validators.errorMessages.phone
};
export const comment_message = {
    required: true
};
export const generic_required = {
    required: true
};



export const registrationCount = {
   required: true,
   validator: val => Validators.isValidNumber(val), 
};